import { WalletOverviewDto, WalletTransactionRow } from "@/app/core/dtos/wallet.dto";
import type { ProviderBeneficiary, ProviderPayout, ProviderPayoutMethod, ProviderWallet } from "@handshake/core-types";
import type { ValidatePayoutBeneficiaryFailureKind } from "./validate-payout-beneficiary-error.util";
import { createAction, props } from "@ngrx/store";

export const loadWalletOverview = createAction("@Wallet/Load Wallet Overview", props<{ businessId: string }>());
export const loadWalletOverviewSuccess = createAction("@Wallet/Load Wallet Overview success", props<{ walletOverview: WalletOverviewDto }>());
export const loadWalletOverviewFailure = createAction("@Wallet/Load Wallet Overview failure", props<{ error: string }>());

export const loadPaymentWallets = createAction("@Wallet/Load payment wallets", props<{ businessId: string }>());
export const loadPaymentWalletsSuccess = createAction("@Wallet/Load payment wallets success", props<{ paymentWallets: ProviderWallet[] }>());
export const loadPaymentWalletsFailure = createAction("@Wallet/Load payment wallets failure", props<{ error: string }>());

export const loadWalletTransactions = createAction(
  "@Wallet/Load Wallet Transactions",
  props<{ businessId: string; page: number; limit: number; transactionType?: string; source?: "handshake" | "nucleus" | "all" }>()
);
export const loadWalletTransactionsSuccess = createAction(
  "@Wallet/Load Wallet Transactions success",
  props<{ walletTransactions: WalletTransactionRow[] }>()
);
export const loadWalletTransactionsFailure = createAction("@Wallet/Load Wallet Transactions failure", props<{ error: string }>());

export const loadBeneficiary = createAction("@Wallet/Load Beneficiary", props<{ businessId: string }>());
export const loadBeneficiarySuccess = createAction("@Wallet/Load Beneficiary success", props<{ beneficiary: ProviderBeneficiary | null }>());
export const loadBeneficiaryFailure = createAction("@Wallet/Load Beneficiary failure", props<{ error: string }>());

export const setBeneficiaryLocally = createAction("@Message/Set Beneficiary Locally", props<{ beneficiary: ProviderBeneficiary }>());

export const loadPaymentPayouts = createAction("@Wallet/Load payment payouts", props<{ businessId: string; page: number; limit: number }>());
export const loadPaymentPayoutsSuccess = createAction("@Wallet/Load payment payouts success", props<{ paymentPayouts: ProviderPayout[] }>());
export const loadPaymentPayoutsFailure = createAction("@Wallet/Load payment payouts failure", props<{ error: string }>());

export const loadPayoutParam = createAction("@Wallet/loadPayoutParam", props<{ payoutMethod: string }>());
export const loadedPayoutParamSuccess = createAction("@Wallet/loadedPayoutParamSuccess", props<{ data: ProviderPayoutMethod }>());
export const loadedPayoutParamFailure = createAction("@Wallet/loadedPayoutParamFailure", props<{ error: string }>());

export const validatePayoutBeneficiary = createAction("@Wallet/validatePayoutBeneficiary", props<{ businessId: string }>());
export const validatePayoutBeneficiarySuccess = createAction("@Wallet/validatePayoutBeneficiarySuccess", props<{ data: unknown }>());
export const validatePayoutBeneficiaryFailure = createAction(
  "@Wallet/validatePayoutBeneficiaryFailure",
  props<{ error: string; failureKind: ValidatePayoutBeneficiaryFailureKind }>()
);
export const resetValidatePayoutBeneficiary = createAction("@Wallet/resetValidatePayoutBeneficiary");
